/**
 * Upload Documents tab — single entry point for uploading profile documents.
 * Supports bulk: drop several PDFs, set a type per file, upload all at once.
 */
import { Alert, AlertDescription, AlertTitle } from '@finmin/ui';
import { FileUp } from 'lucide-react';
import { BulkUploadCard } from '@/features/insurance/bulk-upload-card';
import { ProcessDocumentsCard } from '@/features/insurance/process-documents-card';

export function UploadTab() {
  return (
    <div className="space-y-5">
      <Alert>
        <FileUp className="h-4 w-4" />
        <AlertTitle>Add your policies & statements</AlertTitle>
        <AlertDescription>
          Upload term/health insurance, NPS, or investment statements, then hit
          “Start extraction” to read each one — the details appear in the
          matching tab.
        </AlertDescription>
      </Alert>

      <BulkUploadCard />

      <ProcessDocumentsCard />
    </div>
  );
}
